/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface Tag { 
    name: string;
    color: string;
    uid: string;
    scope: Tag.ScopeEnum;
}
export namespace Tag {
    export type ScopeEnum = 'DATA_MODEL' | 'DATA_INSTANCE';
    export const ScopeEnum = {
        DataModel: 'DATA_MODEL' as ScopeEnum,
        DataInstance: 'DATA_INSTANCE' as ScopeEnum
    };
}


